// libs
import React, { useEffect } from 'react';

// component
import WidgetRendererDesktop from 'shared/components/WidgetRendererSwitch/Desktop';
import MetaInfo from 'shared/components/AdPlatformWidgets/components/MetaInfo';
import IOElement from 'shared/components/IOElement';

// styles
import { ScrollToTop } from './styles';

// defs
import { ILandingPageProps } from 'shared/components/AdPlatformWidgets/types';

// analytics
import { onPageLoad } from 'shared/layouts/LandingPage/analytics';

// hooks
import useCsrSsrSplit from 'shared/hooks/useCsrSsrSplit';

//helpers
import { getMetaData } from 'shared/components/AdPlatformWidgets/helpers';

interface ILandingPageChild {
  landingPageData: ILandingPageProps['landingPageData'];
  pageName: string;
}

function Child({ landingPageData, pageName }: ILandingPageChild) {
  // hook
  const {
    pageFirstFoldData,
    pageBelowTheFoldData,
    showBelowTheFold,
    onVisible,
    eagerLoadingCount,
  } = useCsrSsrSplit(landingPageData);

  useEffect(() => {
    onPageLoad(pageName);
  }, [pageName]);

  const metaData = getMetaData(landingPageData);

  return (
    <>
      <MetaInfo metaData={metaData} />
      <WidgetRendererDesktop
        landingPageData={pageFirstFoldData}
        pageName={pageName}
        eagerLoadingCount={eagerLoadingCount}
      />
      <IOElement onVisible={onVisible} once />
      {showBelowTheFold && (
        <WidgetRendererDesktop
          landingPageData={pageBelowTheFoldData}
          pageName={pageName}
          eagerLoadingCount={eagerLoadingCount}
        />
      )}
      <ScrollToTop />
    </>
  );
}

export default Child;
